// src/components/about/ClientCta.tsx
import { useNavigate } from 'react-router-dom';
import { useReducedMotion } from 'framer-motion';

import { aboutConfig } from '../../config/aboutConfig';
import { motionSet, STAGGER } from './motion';
import {
  CtaRoot,
  CtaInner,
  CtaGrid,
  CtaMain,
  Eyebrow,
  EyebrowMark,
  Heading,
  Lede,
  CtaRow,
  PrimaryCta,
  SecondaryCta,
  CtaList,
  CtaItem,
  ItemLabel,
  ItemDetail,
} from './ClientCta.styles';

const headingId = 'about-cta-heading';

const ClientCta = () => {
  const navigate = useNavigate();
  const reduceMotion = useReducedMotion() ?? false;

  const { eyebrow, heading, lede, capabilities, cta } = aboutConfig.clientCta;

  const motion = motionSet(reduceMotion);
  const rise = motion.reveal;

  return (
    <CtaRoot aria-labelledby={headingId}>
      <CtaInner>
        <CtaGrid
          variants={motion.group(STAGGER.group)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <CtaMain variants={motion.group(STAGGER.group)}>
            <Eyebrow variants={rise}>
              <EyebrowMark aria-hidden="true" />
              {eyebrow}
            </Eyebrow>

            <Heading id={headingId} variants={rise}>
              {heading}
            </Heading>

            <Lede variants={rise}>{lede}</Lede>

            <CtaRow variants={rise}>
              <PrimaryCta
                label={cta.primary.label}
                onClick={() => navigate(cta.primary.to)}
              />
              <SecondaryCta
                label={cta.secondary.label}
                onClick={() => navigate(cta.secondary.to)}
              />
            </CtaRow>
          </CtaMain>

          <CtaList variants={motion.group(STAGGER.list)}>
            {capabilities.map((item) => (
              <CtaItem key={item.label} variants={rise}>
                <ItemLabel>{item.label}</ItemLabel>
                <ItemDetail>{item.detail}</ItemDetail>
              </CtaItem>
            ))}
          </CtaList>
        </CtaGrid>
      </CtaInner>
    </CtaRoot>
  );
};

export default ClientCta;
